<!--
  author：Zoufx
  description：用户
  date：2020/9/3
-->
<template>
  <div class="table_container">
    <el-row style="margin-bottom:10px">
      <el-form inline :model="searchForm">
        <el-form-item label="日期">
          <el-date-picker v-model="searchForm.searchDatetimerange" type="datetimerange"
                          :picker-options="datetimerangePickerOptions" range-separator="至"
                          start-placeholder="开始日期" end-placeholder="结束日期"
                          value-format="yyyy-MM-dd HH:mm:ss" size="medium"/>
        </el-form-item>
        <el-form-item label="用户名">
          <el-input v-model="searchForm.loginName" placeholder="请输入用户名" size="medium"/>
        </el-form-item>
        <el-form-item label="姓名">
          <el-input v-model="searchForm.realName" placeholder="请输入姓名" size="medium"/>
        </el-form-item>
        <el-form-item label="角色">
          <el-select v-model="searchForm.roleId" placeholder="请选择角色" style="width: 100%" size="medium">
            <el-option key="all" label="全部" value=""/>
            <el-option v-for="userRole in roleData" :key="userRole.id" :label="userRole.roleName"
                       :value="userRole.id"/>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="部门" class="block">-->
<!--          <el-cascader placeholder="请选择部门"-->
<!--                       :options="deptData"-->
<!--                       :props="{ multiple: true ,checkStrictly: true}"-->
<!--                       clearable-->
<!--                       collapse-tags-->
<!--                       v-model="searchForm.deptIds"-->
<!--                       ></el-cascader>-->
<!--        </el-form-item>-->
      </el-form>
    </el-row>
    <el-row>
      <el-button type="primary" icon="el-icon-plus" @click="handleAdd" size="medium">新建</el-button>
      <div style="float: right; right: -10px;padding-bottom: 10px;">
        <el-button type="warning" icon="el-icon-search" @click="handleSearchSubmit" size="medium">查询</el-button>
        <el-button type="info" icon="el-icon-refresh-left" @click="handleSearchReset" size="medium">重置</el-button>
      </div>
    </el-row>
    <el-row>
      <el-table highlight-current-row :data="tableData" v-loading="$store.state.loading">
        <el-table-column min-width="100" prop="loginName" label="用户名" align="center" fixed/>
        <el-table-column min-width="100" prop="nickName" label="昵称" align="center"/>
        <el-table-column min-width="100" prop="realName" label="真实姓名" align="center"/>
        <el-table-column min-width="100" prop="userTel" label="电话" align="center"/>
        <el-table-column min-width="100" prop="roleName" label="角色名称" align="center"/>
        <el-table-column min-width="150" prop="userStatus" label="部门" align="center">
          <template slot-scope="scope">
            <el-tag v-for="dept in scope.row.deptList" style="margin-right: 5px;">
              {{dept.name}}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column min-width="150" prop="userStatus" label="状态" align="center">
          <template slot-scope="scope">
            <el-switch :value="scope.row.userStatus" active-text="正常" inactive-text="停用"
                       active-value="0" inactive-value="2" @change="handleSwitchChange($event, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column min-width="150" label="操作" align="center">
          <template slot-scope="scope">
            <el-tooltip :open-delay="700" effect="light" content="修改" placement="top">
              <el-button type="success" @click="handleEdit(scope.$index, scope.row)"
                         icon="el-icon-edit" size="mini"/>
            </el-tooltip>
            <el-tooltip :open-delay="700" effect="light" content="删除" placement="top">
              <el-button type="danger" @click="handleDelete(scope.$index, scope.row)"
                         icon="el-icon-delete" size="mini"/>
            </el-tooltip>
            <el-tooltip :open-delay="700" effect="light" content="重置密码" placement="top-end">
              <el-button type="warning" @click="handlePwdReset(scope.$index, scope.row)"
                         icon="el-icon-key" size="mini"/>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <el-row class="table_pagination">
      <el-pagination background :pageCount="pageCount" :currentPage="currentPage" :page-size="pageSize"
                     layout="prev, pager, next" @current-change="handleCurPageChange"
                     hide-on-single-page/>
    </el-row>
    <sys-user-form :formVisible.sync="formVisible" :selRow="selRow" :submitUrl="submitUrl" :roleData="roleData"
                   :deptData="deptData" @refreshList="getTableData"/>
  </div>
</template>

<script>
  import {commonListMixin} from "../../utils/commonListMixin";
  import SysUserForm from "./form/SysUserForm";
  import { mapState } from 'vuex';

  export default {
    name: "SysUserIndex",
    components: {SysUserForm},
    mixins: [commonListMixin],
    data() {
      return {
        roleData: [],
        deptData: [],
        url: {
          list: '/sysUser/findList',
          add: '/sysUser/save',
          edit: '/sysUser/update',
          delete: '/sysUser/updateStatus'
        }
      }
    },
    computed:{
      ...mapState({
        userInfo:'userInfo',
      }),
    },
    mounted() {
      this.getRoleData();
      this.getDeptData();
    },
    methods: {
      beforeDelete(row) {
        return {userStatus: 1}
      },
      async getRoleData() {
        let {obj} = await this.postRequest('/sysRole/findAll');
        this.roleData = obj
      },
      async getDeptData() {
        let {obj} = await this.postRequest('/sysDept/findTree');
        this.deptData = obj;
      },
      async handlePwdReset(index, row) {
        let isConfirm = await this.$confirm('确认要重置密码？', '提示', {type: 'warning'}).catch(() => {
        });
        if (!isConfirm) return;
        await this.postRequest('/sysUser/updatePwd', {'id': row.id, 'updatePwdFlag': 'reset'});
        this.getTableData()
      },
      async handleSwitchChange(val, row) {
        await this.postRequest('/sysUser/updateStatus', {'id': row.id, 'userStatus': val});
        this.getTableData()
      }
    }
  }
</script>

<style>

</style>
